"use client";

import { publishModalVisibility } from "@/app/redux/features/modal/modalSlice";
import { useAppDispatch } from "@/app/redux/hooks";
import { useEffect } from "react";

export default function SavingsInfoModal() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  return (
    <div className="flex flex-col gap-6 items-center w-full">
      <div className="text-2xl font-bold font-jost leading-7.5 text-dark-1 text-center">
        How your savings are calculated
      </div>

      <div className="flex flex-col gap-4 w-full">
        <div className="relative flex flex-col gap-4 items-start w-full bg-white border border-black/[0.08] rounded-xl overflow-hidden px-3 py-4">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-botb" />
          <div className="bg-gradient-botb bg-clip-text text-transparent text-base font-semibold font-jost leading-5.5">
            Your total savings
          </div>
          <p className="m-0 p-0 tracking-[0] text-secondary text-base font-normal font-jost leading-5.5">
            Everything you have saved as a BOTB Pass member{" "}
            <span className="font-medium">across all completed subscription cycles</span>, compared to buying the same
            tickets individually at full price.
          </p>
        </div>

        <div className="relative flex flex-col gap-4 items-start w-full bg-white border border-black/[0.08] rounded-xl overflow-hidden px-3 py-4">
          <div
            className="absolute top-0 left-0 w-full h-1.5"
            style={{ backgroundImage: "linear-gradient(160deg, #1500ff 2%, #7366ff 101.5%)" }}
          />
          <div
            className="bg-clip-text text-transparent text-base font-semibold font-jost leading-5.5"
            style={{ backgroundImage: "linear-gradient(160deg, #1500ff 2%, #7366ff 101.5%)" }}>
            Current savings
          </div>
          <div className="flex flex-col gap-4 text-secondary text-base font-normal font-jost leading-5.5">
            <p className="m-0 p-0 tracking-[0]">
              What you have saved so far <span className="font-medium">this subscription cycle</span>, compared to
              buying the same tickets at full price. This updates every month, on both monthly and yearly subscriptions.
            </p>
            <p className="m-0 p-0 tracking-[0]">
              This figure may take a few days to start appearing and is added to your total savings at the end of the
              cycle.
            </p>
          </div>
        </div>
      </div>

      <button
        onClick={() => dispatch(publishModalVisibility({ isOpen: false }))}
        className="flex items-center justify-center w-full h-11 bg-primary rounded text-white text-base font-medium font-jost leading-5.5">
        GOT IT
      </button>
    </div>
  );
}
